import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../../../api/client';
import { Endpoints, type LicenseStatusResponse } from '../../../api/types';

/**
 * Reads `GET /api/v1/license/status` so the schema editor can gate per-tenant features (e.g. whether the
 * tenant may choose the OCR source). Self-contained in the schema feature to avoid a cross-feature import;
 * cached for a minute since the flags rarely change within a session.
 */
export function useLicenseFeatures(): UseQueryResult<LicenseStatusResponse> {
  return useQuery({
    queryKey: ['schema', 'license-status'],
    queryFn: ({ signal }) => apiFetch<LicenseStatusResponse>(Endpoints.licenseStatus, { signal }),
    staleTime: 60_000,
  });
}
